"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentHeight = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var getHeight = function getHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};

/**
 * Use this hook to get changes in viewport width. Useful when trying to
 * to implement responsiveness.
 *
 * @returns {number}
 */
var useCurrentHeight = exports.useCurrentHeight = function useCurrentHeight() {
  var _useState = (0, _react.useState)(getHeight()),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  (0, _react.useEffect)(function () {
    var resizeListener = function resizeListener() {
      setHeight(getHeight());
    };
    window.addEventListener('resize', resizeListener);
    return function () {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);
  return height;
};